import { useNavigate } from 'react-router-dom'
import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { useDispatch } from 'react-redux'
import { appGetAllPost } from '../../store/post'
import { postExportColumns } from '../../config/exportColumns/postExportColumns'

function Post() {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Posts</div>
					<div>
						<ExportButton
							fetchAction={params => dispatch(appGetAllPost({ ...params, loading: false }))}
							filters={{}}
							columns={postExportColumns}
							fileName="Posts"
							sheetName="Post List"
							buttonText="Export Posts"
						/>
						<button
							className="btn btn-labeled btn-success"
							type="button"
							style={{ fontSize: '17px', marginLeft: '10px' }}
							onClick={() => navigate('/post/new')}
						>
							<span className="btn-label">
								<em className="fas fa-plus"></em>
							</span>
							New Post
						</button>
					</div>
				</div>
				<TableFilter />
			</div>
		</>
	)
}

export default Post
